<dx-popup
  [visible]="displayDialog()"
  (visibleChange)="displayDialog.set($event)"
  [title]="title()"
  [width]="720"
  [height]="'auto'"
  [showCloseButton]="true">

  <form novalidate>
    <div class="dialog-line">
      <div class="label" title="Allergènes">Allergènes</div>
      <div class="value">
        <yo-tagbox
          [data]="allergeneSvc.allergeneResource.value()"
          [selectedItems]="selectedAllergeneIdList()"
          (onValueChange)="onAllergeneChange($event)">
        </yo-tagbox>
      </div>
    </div>

    <!-- APPELLATIONS -->
    <div class="dialog-line">
      <div class="label" title="Appellations">Appellations</div>
      <div class="value">
        <yo-tagbox
          [data]="appellationSvc.appellationResource.value()"
          [selectedItems]="selectedAppellationIdList()"
          (onValueChange)="onAppellationChange($event)">
        </yo-tagbox>
      </div>
    </div>

    <div class="dialog-line">
      <span class="label font-italic">Attention : en enregistrant, ce plat sera considéré comme modifié, même si aucun changement n’a été apporté.</span>
    </div>

      <div class="custom-button-container-right mg-t-10">
        <yo-button
          label="Enregistrer"
          iconClass="fas fa-save"
          [theme]="ButtonThemeEnum.SAVE"
          (onClick)="save()">
        </yo-button>
        <yo-button
          label="Fermer"
          iconClass="fas fa-times"
          [theme]="ButtonThemeEnum.CANCEL"
          (onClick)="displayDialog.set(false)">
        </yo-button>
      </div>
  </form>

</dx-popup>
